import { render, staticRenderFns } from "./TarjetaPausadosCancelados.vue?vue&type=template&id=35630f14&scoped=true&"
import script from "./TarjetaPausadosCancelados.vue?vue&type=script&lang=js&"
export * from "./TarjetaPausadosCancelados.vue?vue&type=script&lang=js&"
import style0 from "./TarjetaPausadosCancelados.vue?vue&type=style&index=0&id=35630f14&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35630f14",
  null
  
)

export default component.exports